import "./App.css";
import Navigation from "./components/Home/Navigation";

function App() {
  return (
    <div className="App">
      <Navigation></Navigation>
    </div>
  );
}

export default App;
